module.exports = __webpack_public_path__ + "static/media/imgGalleryM4.bc0a4d8f.svg";